<template>
    <div
        v-if="visible"
        class="logout-wrap"
    >
        <div 
            class="mask" 
            @touchmove.prevent
        />
        <div class="content">
            <div class="title">退出登录</div>
            <div class="des">确认要退出登录吗？</div>
            <div class="btn">
                <div
                    class="leave"
                    @click="handleLogout">离开</div>
                <div
                    class="cancle"
                    @click="visible = false">取消</div>
            </div>
        </div>
    </div>
</template>
<script>
import postLogout from "../api/logout.js";
export default {
    name: "LoginOutDialog",
    data() {
        return {
            visible: false
        };
    },
    methods: {
        openDialog() {
            this.visible = true;
        },
        handleLogout() {
            postLogout().then(() => {
                this.visible = false;
                this.$emit("initPage");
            }).catch(err => {
                this.$toast(err.message || "退出登录失败");
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import '@/assets/sass/vws.scss';
.logout-wrap {
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.9);
    top: 0;
    left: 0;
    z-index: 100;
    .mask {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
    }
    .content {
        width: vws(570px);
        height: vws(278px);
        background: #FFFFFF;
        border-radius: vws(36px);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        line-height: 1;
        text-align: center;
        .title {
            font-size: vws(40px);
            font-family: PingFang SC;
            font-weight: 500;
            color: #272625;
            margin: vws(43px) auto vws(29px);
        }
        .des {
            font-size: vws(30px);
            font-family: PingFang SC;
            font-weight: 400;
            color: #272625;
        }
        .btn {
            margin-top: vws(37px);
            display: flex;
            &::before {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                content: '';
                width: vws(530px);
                height: vws(1px);
                background: #E8E8E8;
            }
            .leave {
                margin: vws(32px) vws(194px) 0 vws(125px);
                font-size: vws(32px);
                font-family: PingFang SC;
                font-weight: 500;
                color: #646464;
            }
            .cancle {
                margin-top: vws(32px);
                font-size: vws(32px);
                font-family: PingFang SC;
                font-weight: 500;
                color: #FC673D;
            }
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/pages/native/pay/vip/link_vip_multiple/comp/LoginOutDialog.vue